<div class="col-12 p1">
    @if (begining) {
    <div [innerHtml]="begining"></div>
    <div class="_dots">...</div>
    <div class="_extra"
          [innerHtml]="rest"></div>
    <input type="checkbox"
           id="btn" />
    <label class="p-l-1 link-1 underline"
           [class._hide-opened]="!readLess()"
           for="btn"
           [attr.data-read-more]="'more' | translate"
           [attr.data-read-less]="'close' | translate"></label>
    } @else {
    <div [innerHtml]="text"></div>
    }
</div>